import React, { Component } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import styled from "styled-components";
import { FormControl, InputLabel, Grid, Input } from "@material-ui/core";
import DatePicker from "material-ui-pickers/DatePicker";
import { PrimaryButton, ButtonSizeOptions, SecondaryButton } from "@loanbossinc/component-library";
import PageWrapper from "components/Global/PageOrganization/PageWrapper";

import { curves, shocks, dayOfMonth } from "../../Constants/DropDownLists";
import { CAP_VOLS, MARKET_EXPECTATIONS_SHOCK, PARALLEL_SHOCK } from "../../Constants/Constants";
import { StyledGrid } from "../../Constants/StyledComponents";
import DropDownFormControl from "../Components/DropDownFormControl";

const ButtonBar = styled(Grid)`
  display:flex;
  align-items:flex-end;
  justify-content:flex-start;
  & button {
    margin-left: 4px;
    margin-right: 4px;
  }

`;
const StyledInputLabel = styled(InputLabel)`& {
  /* Work Sans / 12 Semibold CAPS */
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  
  
  /* Text / Dark Gray */
  color: #5F6368;
  }
`;
const StyledDatePicker = styled(DatePicker)`& {
  /* Work Sans / 12 Semibold CAPS */
  font-family: Work Sans;
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: 14px;
  
  
  /* Text / Dark Gray */
  color: #5F6368;
  }
`;
class CalculatorTestHarnessSearch extends Component {
  constructor(props) {
    super(props);
  }

  shouldDisableShockValue() {
    return (
      this.props.state.curve !== CAP_VOLS &&
      this.props.state.shockType === MARKET_EXPECTATIONS_SHOCK
    );
  }

  shouldDisableShockScenario() {
    return this.props.state.curve === CAP_VOLS;
  }

  shouldAddBpsToLabel() {
    return this.props.state.shockType !== PARALLEL_SHOCK;
  }

  render() {
    if (!this.props.state) {
      return null;
    }

    return (
      <PageWrapper>
        <Grid
          container
          direction="row"
        >
          <StyledGrid item xs={2}>
            <DropDownFormControl
              htmlFor="curve"
              labelName="Curve"
              value={this.props.state ? this.props.state.curve.toString() : ""}
              onChange={this.props.handleChange}
              inputProps={{ name: "curve" }}
              menuItemList={curves}
            />
          </StyledGrid>
          <StyledGrid item xs={2}>
            <DropDownFormControl
              htmlFor="shockScenario"
              labelName="Shock Scenario"
              value={this.props.state.shockType.toString()}
              onChange={this.props.handleChange}
              inputProps={{ name: "shockType" }}
              menuItemList={shocks}
              disabled={this.shouldDisableShockScenario()}
            />
          </StyledGrid>
          <StyledGrid item xs={2}>
            <DropDownFormControl
              htmlFor="dayOfMonth"
              labelName="Day of Month for Resets"
              value={this.props.state.dayOfMonth}
              onChange={this.props.handleChange}
              inputProps={{ name: "dayOfMonth" }}
              menuItemList={dayOfMonth}
            />
          </StyledGrid>
          <StyledGrid item xs={2}>
            <FormControl className="selectMenu">
              <StyledInputLabel htmlFor="shockValue">{this.shouldAddBpsToLabel() ? "Shock Value" : "Shock Value (bps)"}</StyledInputLabel>
              <Input
                type="number"
                name="shockValue"
                value={this.props.state.shockValue.toString()}
                onChange={this.props.handleChange}
                disabled={this.shouldDisableShockValue()}
              />
            </FormControl>
          </StyledGrid>
          <StyledGrid item xs={2}>
            <FormControl className="selectMenu">
              <StyledDatePicker
                label="Base Date"
                name="baseDate"
                value={this.props.state.baseDate}
                onChange={this.props.handleDateChange}
              />
            </FormControl>
          </StyledGrid>
        </Grid>

        <Grid
          container
          direction="row"
          justify="flex-end"
          style={{ marginTop: 50 }}
        >
          <ButtonBar item xs={4}>

            <PrimaryButton
              style={{ marginRight: 24 }}
              label="Calculate"
              onClick={this.props.submit}
              size={ButtonSizeOptions.smFluid}
            />
            <SecondaryButton
              label="Download"
              onClick={this.props.downloadTestData}
              size={ButtonSizeOptions.smFluid}
            />

          </ButtonBar>
        </Grid>
      </PageWrapper>
    );
  }
}

const mapStateToProps = ({ authentication }) => ({
  authentication
});

export default compose(connect(mapStateToProps))(CalculatorTestHarnessSearch);
